export default "__VITE_ASSET__b3bdc0eb__"